



















































import { Component, Vue, Prop } from 'vue-property-decorator';
import TOCNode from '@/models/KnowledgeBase/TOCNode';
import KBContentListItem from '@/models/KnowledgeBase/KBContentListItem';
import PageNames from '@/router/PageNames';

@Component({
  name: 'TOCNavigationNode'
})
export default class TOCNavigationNode extends Vue {
  @Prop({ required: true }) nodes!: TOCNode[];
  @Prop({ required: true }) contentList!: KBContentListItem[];
  @Prop({ required: true }) sectionIndex!: number;
  @Prop({ default: () => [] }) nodePath!: number[];
  @Prop({ default: 1 }) depth!: number;

  toggleFolder(index: number) {
    // Use Vue.set for reactivity
    this.$set(this.nodes[index], 'expanded', !this.nodes[index].expanded);
  }

  getTitleForContent(contentId: string): string {
    const item = this.contentList.find(c => c.id === contentId);
    return item?.title || 'Untitled';
  }

  getSlugForContent(contentId: string): string {
    const item = this.contentList.find(c => c.id === contentId);
    return item?.slug || contentId;
  }
}
